import { newDate, formatCustomDate } from "helpers/dateTools";
import { formatDiscount } from "helpers/formatDiscount";

import { promocodeTypes } from "./promocodeTypes";

const {
    GET_PROMOCODES,
    NEW_PROMOCODE,
    SET_PROMOCODE_FILTERS,
    SET_BRANDS,
    SET_SELECTED_PROMOCODE,
    DELETE_PROMOCODE,
    UPDATE_PROMOCODE
} = promocodeTypes

const useTypes = [
    { value: 'single_use', label: 'Un solo uso' },
    { value: 'n_buy', label: 'N Compra' }
]
const discountTypes = [
    { value: 'LTS', label: 'LITROS' },
    { value: 'KGS', label: 'KILOS' },
    { value: 'IMPORTE', label: 'IMPORTE' },
    { value: 'PORCENTAJE', label: 'PORCENTAJE' }
]

const statusList = [
    { value: 'ACTIVE', label: 'Activo' },
    { value: 'INACTIVE', label: 'Inactivo' }
]

export const formatPromocode = (payload) => ({
    ...payload,
    idStation: payload.rules?.length ? payload.rules[0].station.id : null,
    brand: payload.rules?.length ? payload.rules[0].brand.name : '',
    expDate: formatCustomDate(payload.finalValidity),
    discount: payload.rules?.length ? formatDiscount(payload.rules[0]) : '',
    minPurchase: payload.rules?.length ? '$' + payload.rules[0].minimum : ''
})

const initialState = {
    station: [],
    startDate: newDate(),
    endDate: newDate(),

    promocodeSelected: {},

    config: {
        page: 0,
        pageSize: 20,
        filtered: [],
        sorted: []
    },
    addMode: true,

    stationBrands: [],
    discountTypes,
    useTypes,
    statusList,
    promocodes: [],
    promocode: {},
}

export const promocodesReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case NEW_PROMOCODE:
            return {
                ...state,
                promocodes: state?.station?.value
                    ? [...state.promocodes, formatPromocode(payload)]
                    : state.promocodes
            }
        case UPDATE_PROMOCODE:
            return {
                ...state,
                promocodes: state.promocodes.map(item =>
                    item.id === payload.id ? formatPromocode(payload) : item
                )
            }
        case GET_PROMOCODES:
            return {
                ...state,
                ...payload
            }
        case SET_SELECTED_PROMOCODE:
            return {
                ...state,
                addMode: payload.addMode,
                promocodeSelected: payload.promocode
            }
        case SET_PROMOCODE_FILTERS:
            return {
                ...state,
                [payload.key]: payload.data,
            }
        case DELETE_PROMOCODE:
            return {
                ...state,
                promocodes: state.promocodes.filter(item => item.id !== payload)
            }
        case SET_BRANDS:
            return {
                ...state,
                stationBrands: payload
            }

        default:
            return state
    }
}